import React from 'react';

import { Container } from './styles';

import dj from '../../assets/dj.gif';

function Commands() {
    return (
        <Container>
            <div>

                <img src={dj} alt="" />
                <h1>Commands</h1>
            </div>
            {/* help
            invit
            loop
            lyrics
            np
            owners
            pause
            play
            playlist
            prunning
            queue
            remove
            resume
            search
            shuffle
            skip
            skipto
            stop
            volume */}

            <section>
                <div>
                    <h2>sy!help (h)</h2>
                    <p>Lista de todos os comandos.</p>
                </div>

                <div>
                    <h2>sy!invit (inv)</h2>
                    <p>Emite um link para me colocar no servidor.</p>
                </div>

                <div>
                    <h2>sy!loop (l)</h2>
                    <p>Alterna as músicas da fila.</p>
                </div>

                <div>
                    <h2>sy!lyrics (ly)</h2>
                    <p>Obter letras da música atualmente sendo reproduzida.</p>
                </div>

                <div>
                    <h2>sy!np</h2>
                    <p>Mostrar agora a reprodução da música.</p>
                </div>

                <div>
                    <h2>sy!owners (ow)</h2>
                    <p>Mostra com quem entrar em contato.</p>
                </div>

                <div>
                    <h2>sy!pause</h2>
                    <p>Mostra com quem entrar em contato.</p>
                </div>

                <div>
                    <h2>sy!play (p)</h2>
                    <p>Toca músicas do YouTube ou Soundcloud.</p>
                </div>

                <div>
                    <h2>sy!playlist (pl)</h2>
                    <p>Reproduzir uma lista de reprodução do youtube.</p>
                </div>

                <div>
                    <h2>sy!prunning</h2>
                    <p>Alternar remoção de mensagens de bot.</p>
                </div>

                <div>
                    <h2>sy!queue (q)</h2>
                    <p>Mostrar a fila de músicas em reprodução.</p>
                </div>

                <div>
                    <h2>sy!remove</h2>
                    <p>Remover música da fila.</p>
                </div>

                <div>
                    <h2>sy!resume (r)</h2>
                    <p>Retomar a música atualmente sendo reproduzida.</p>
                </div>

                <div>
                    <h2>sy!search</h2>
                    <p>Pesquise e selecione vídeos para reproduzir.</p>
                </div>

                <div>
                    <h2>sy!shuffle</h2>
                    <p>Deixa a fila aleatória.</p>
                </div>

                <div>
                    <h2>sy!skip (s)</h2>
                    <p>Ignorar a música atualmente sendo reproduzida.</p>
                </div>

                <div>
                    <h2>sy!skipto (st)</h2>
                    <p>Ir para o número da fila selecionado.</p>
                </div>

                <div>
                    <h2>sy!stop</h2>
                    <p>Parar a música.</p>
                </div>

                <div>
                    <h2>sy!volume (v)</h2>
                    <p>Alterar o volume da música atualmente sendo reproduzida.</p>
                </div>

            </section>
        </Container>
    );
}

export default Commands;